<template>
  <section class="job-content">
    <div class="container">
      <el-carousel :interval="4000" indicator-position="outside" height="112px">
        <el-carousel-item class="banner">
          <img :src="banner1">
        </el-carousel-item>
        <div class="headerFontRecuit">
          <span class="headerFontRecuitOne">魅力城轨 &nbsp;  美丽徐州</span>
        </div>
      </el-carousel>
    </div>
    <div :style="{'backgroundImage': 'url(' + img3 + ')'}" class="bgAll">
      <div :style="{'min-height': bgHeight}" class="jobContent">
        <div class="pathInfoDetail">当前位置：人才招聘 > 岗位详情</div>
        <div class="jobHeader">
          <div class="left">
            <p class="job-title">{{ data.name }}</p>
            <p class="time">发布日期：{{ data.RELEASEDATE }} |  截止日期：{{ data.JZRQ }}</p>
          </div>
          <div style="width: 15%;min-width: 101px">
            <el-button type="danger" class="resume-submit" @click="dialogVisible = true">申请职位<i class="el-icon-arrow-right el-icon--right"/></el-button>
          </div>
        </div>
        <div class="jobInfo">
          <div class="info-left">
            <p class="info-title">招聘活动</p>
            <p>{{ data.zphd }}</p>
            <p class="info-title">招聘人数</p>
            <p>{{ data.renum }}</p>
            <p class="info-title">性别</p>
            <p><template v-if="data.sex === '0'">不限</template><template v-if="data.sex === '1'">男</template><template v-if="data.sex === '2'">女</template></p>
            <p class="info-title">招聘部门</p>
            <p>{{ data.dept_NAME }}</p>
            <p class="info-title">学历要求</p>
            <p>{{ data.education }}</p>
            <!-- <p class="info-title">年龄要求</p>
            <p><template v-if="data.nlxz === ''">无</template><template v-else>{{ data.nlxz }}之后</template></p> -->
          </div>
          <div class="info-right">
            <h3>职位职责：</h3>
            <p v-html="data.jobexplain" />
            <h3>任职要求：</h3>
            <p v-html="data.postrequire" />
          </div>
        </div>
      </div>
    </div>
    <div style="display: none" class="job-message-container container">
      <el-row>
        <el-col :offset="5" :span="12">
          <h3 class="job-title">{{ data.name }}</h3>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="5" :span="14">
          <table class="gridtable">
            <tr>
              <td>
                招聘活动：{{ data.zphd }}
              </td>
              <td>
                招聘部门：{{ data.dept_NAME }}
              </td>
            </tr>
            <tr>
              <td>
                招聘人数：{{ data.renum }}
              </td>
              <td>
                学历要求：{{ data.education }}
              </td>
            </tr>
            <tr>
              <td>
                性别：<template v-if="data.sex === '0'">不限</template><template v-if="data.sex === '1'">男</template><template v-if="data.sex === '2'">女</template>
              </td>
              <td>
                年龄要求：<template v-if="data.nlxz === ''">无</template><template v-else>{{ data.nlxz }}之后</template>
              </td>
            </tr>
            <tr>
              <td>
                发布日期：{{ (data.releasedate + '').slice(0, 10) }}
              </td>
              <td>
                截止日期：{{ (data.jzrq + '').slice(0, 10) }}
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="5" :span="14">
          <div class="gwyq">
            <h3>职位职责：</h3>
            <p v-html="data.jobexplain" />
            <h3>任职要求：</h3>
            <p v-html="data.postrequire" />
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :offset="8" :span="8">
          <el-button type="danger" class="resume-submit" @click="dialogVisible = true">申请职位</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      class="recruit-dialog"
      title="报名须知">
      <div class="content" v-html="infor"> 
        
        <!-- <p>1.在整个招聘过程中，请保持所提供的通讯方式畅通。</p>
        <p>2.资格审查贯穿招聘工作全过程，应聘人员报名时提交的信息和提供的有关材料必须真实有效，凡出现以下情况者，即取消其应聘及录用资格：</p>
        <p>（1）提供虚假信息的；</p>
        <p>（2）曾违法乱纪被公安机关处理的；</p>
        <p>（3）曾被开除公职的；</p>
        <p>（4）有其它不良行为和记录的。</p>
        <p>3.我公司在本次招聘过程中，未委托任何机构和个人，应聘者也无须缴纳任何费用。</p>
        <p>4.应聘者可通过电话咨询招聘相关事宜，谢绝应聘者来访。咨询电话：0516-80805211、0516-80801777。</p> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="applyJob">同 意</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import Banner1 from 'assets/PC/banner_zpxqy.png'
import iconIn from 'assets/PC/jiantou_icon_zpxqy.png'
import { parseTime } from 'utils/index'
import { getRecruitDetail,getApplyNotice} from 'api/recruit'
import img3 from 'assets/PC/bg_zpxqy.png'
export default {
  data: () => {
    return {
      img3: img3,
      parseTime,
      bgHeight: '600px',
      banner1: Banner1,
      iconIn: iconIn,
      dialogVisible: false,
      id: null,
      infor:null,
      data: {
        id: null,
        sex: null,
        department: null,
        STATE: null,
        CODE: null,
        NUM: null,
        FL: null,
        RENUM: null,
        SPECIALITY: null,
        EDUCATION: null,
        GZBZ: null,
        JZRQ: null,
        STARTDATE: null,
        NAME: null,
        REQUIRE: null,
        YID: null,
        SALARY: null,
        PLACE: null,
        ENDDATE: null,
        EXPLAIN: null,
        zphd: null,
        ZPLX: null,
        XGZWLB: null,
        XGHYLB: null,
        NIXZ: null,
        RELEASEDATE: null
      }
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        let he = document.body.clientHeight - 65 - 210 - 72
        if (he < 600) {
          he = 600
        }
        this.bgHeight = he + 'px'
      })()
    }
  },
  created() {
    this.id = this.$route.params.id
    this._getRecruitDetail(this.id)
    this.initHeight()
    getApplyNotice().then(res=>{
      this.infor = res.data[0].configValue
    })
  },
  methods: {
    initHeight() {
      const he = document.body.clientHeight - 65 - 210 - 72
      this.bgHeight = he + 'px'
    },
    applyJob() {
      this.dialogVisible = false
      this.$router.push({
        path: '/resume/detail/' + this.id
      })
    },
    _getRecruitDetail(id) {
      getRecruitDetail(id).then((data) => {
        if (data.code > 0) {
          this.data = data.data[0]
          var reg = /[;；]/g
          this.data.jobexplain = this.data.jobexplain.replace(/。/g, '。<br />')
          this.data.jobexplain = this.data.jobexplain.replace(/：/g, '：<br />')
          this.data.jobexplain = this.data.jobexplain.replace(reg, '；<br />')
          this.data.postrequire = this.data.postrequire.replace(/：/g, '：<br />')
          this.data.postrequire = this.data.postrequire.replace(/。/g, '。<br />')
          this.data.postrequire = this.data.postrequire.replace(reg, '；<br />')
        } else {
          this.$message({
            type: 'error',
            message: data.msg
          })
        }
      })
    }
  }
}
</script>
<style >
.bgAll{
  width: 100%;
  height: auto;
  background-position: bottom left;
  background-size: 100%;
  background-repeat: no-repeat;
}
.job-content{
  padding: 0;
}
  .jobContent{
    margin: 0 auto;
    width: 60%;
    background-color: white;
  }
  .jobContent .jobHeader{
    display: flex;
    margin-left: 12px;
    justify-content: space-between;
    align-content: center;
    align-items: center;
  }
  .jobHeader .left .job-title{
    color: #333333;
    font-size: 1.4rem;
    font-weight: bolder;
    margin: 1rem 0 .5rem 0;
  }
  .jobHeader .left .time{
    font-size: 12px;
    color: #666666;
    margin: 0;
  }
  .jobInfo{
    margin-top: 1.5rem;
    display: flex;
    justify-content: space-between;
    box-shadow:-8px 0px 8px #c0c4cc30,   /*左边阴影*/
    8px 0px 8px #c0c4cc30,  /*右边阴影*/
    0px 8px 8px #c0c4cc30;
    flex-wrap: wrap;
    font-size: .8rem;
  }
  .jobInfo .info-left{
    width: 30%;
    background-color: #fafafa;
    padding: 2rem;
  }
  .jobInfo .info-left .info-title{
    font-weight: bolder;
  }
  .jobInfo .info-right{
    width: 70%;
    padding: 2rem;
  }
  .jobInfo .info-right>p{
    line-height: 1.5rem;
  }
  .jobInfo .info-right>h3{
    font-size: 1.6rem;
    color: #cccccc;
    font-weight: normal;
  }
  .pathInfoDetail{
    font-size: 12px;
    border-bottom: #eeeeee solid 1px;
    height: 1.8rem;
    margin: 1rem 0rem 0;
  }
  .headerFontRecuit {
    position: absolute;
    left: 68%;
    z-index: 99;
    top: 28%;
    color: white;
    text-align: center
  }
  .headerFontRecuitOne {
    margin-bottom: 20px;
    display: inline-block;
    font-size: 1.6em;
  }
  .headerFontRecuitTwo {
    font-size: 1.2em;
  }
  .el-button{
    border-radius: 0;
  }
  .el-button--danger{
    background-color: #e70012;
    border: none;
    border-radius: 0;
  }
  .el-button:focus, .el-button:hover{
    color: white;
    border-color: #f9a7a7;
    background-color: #f9a7a7;
  }
  .el-dialog__title{
    font-weight: bolder;
    font-size: 1.2rem;
  }
  .el-dialog__body{
    border-top: #eeeeee solid 1px;
    padding-top: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/recruit/detail.vue